<template>
    <div>
        <product-price :prices="selectedPrices"></product-price>
        <product-spec
            v-model="selectedStorage"
            :specs="myProduct.specs"
            :storages="myProduct.storages"
        ></product-spec>

        <!-- quantity -->
        <div
            style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 20px;
                margin-right: 10px;
            "
        >
            <div>
                <p style="color: #000">數量</p>
            </div>
            <cart-quantity-selector
                style="margin: 5px 20px"
                :storage="selectedStorage"
                v-model="cartData.quantity"
            >
            </cart-quantity-selector>
        </div>
        <div class="dtbtn">
            <add-to-cart-btn
                v-if="this.cartData.quantity"
                :product-id="product.id"
                :cart-data="cartData"
            ></add-to-cart-btn>
            <button
                v-if="!this.cartData.quantity"
                type="button"
                class="btn btn-primary"
            >
                有貨時通知我
            </button>
            <a
                title=""
                href="javascript:void(0);"
                class="heart btn btn-outline-success"
                data-toggle="tooltip"
                data-original-title="Save to Wishlist"
            >
                <i class="fa fa-heart"></i
            ></a>
        </div>
    </div>
</template>
<script>
    import tools from "../../../library/tools";

    export default {
        props: {
            product: {
                default() {
                    return {};
                },
            },
        },
        data() {
            return {
                myProduct: {},
                selectedStorage: {},
                cartData: {
                    storage: undefined,
                    quantity: undefined,
                },
            };
        },
        mounted() {
            this.myProduct = this.product;
            window.tools = tools;
        },
        computed: {
            selectedPrices() {
                if (!this.selectedStorage) return;
                this.cartData.storage = this.selectedStorage.id;
                let { list, suggest, retail } = this.selectedStorage;
                return { list, suggest, retail };
            },
        },
        methods: {
            range: tools.range,
        },
    };
</script>
<style lang="">
</style>